import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-fusionAdd",
  "use": "app-icon-fusionAdd-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"app-icon-fusionAdd\"><path d=\"M7-.01c.515 0 .933.417.933.933v5.132l5.134.001a.933.933 0 010 1.867H7.933v5.133a.933.933 0 01-1.866 0l-.001-5.134H.933a.933.933 0 010-1.866h5.133V.922c0-.516.419-.934.934-.934z\" fill=\"#86A6FC\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol